var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagosBalken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9f9f9d;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_366",
    className: "cls-1",
    d: "M12,0C5.37,0,0,5.37,0,12s5.37,12,12,12,12-5.37,12-12S18.63,0,12,0ZM12,21.6c-5.3,0-9.6-4.3-9.6-9.6S6.7,2.4,12,2.4s9.6,4.3,9.6,9.6-4.3,9.6-9.6,9.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_367",
    className: "cls-1",
    d: "M14.4,9.6h2.4c0-1.7-1.51-3.08-3.6-3.48v-1.32c0-.66-.54-1.2-1.2-1.2-.66,0-1.2.54-1.2,1.2h0v1.32c-2.09.4-3.6,1.78-3.6,3.48s1.51,3.08,3.6,3.48v2.34c-.76-.25-1.2-.68-1.2-1.02h-2.4c0,1.7,1.51,3.08,3.6,3.48v1.32c0,.66.54,1.2,1.2,1.2.66,0,1.2-.54,1.2-1.2h0v-1.32c2.09-.4,3.6-1.78,3.6-3.48s-1.51-3.08-3.6-3.48v-2.34c.76.25,1.2.68,1.2,1.02ZM9.6,9.6c0-.34.44-.77,1.2-1.02v2.04c-.76-.25-1.2-.68-1.2-1.02ZM14.4,14.4c0,.34-.44.77-1.2,1.02v-2.04c.76.25,1.2.68,1.2,1.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagosBalken);
export default __webpack_public_path__ + "static/media/pagos_BALKEN.8a3e49ff1715a73352967ffe38a37adb.svg";
export { ForwardRef as ReactComponent };